import {abstractFilter} from './../abstractFilter';
function F() {
    return (F.is(this) ? this.init : F.F).apply(this, Array.prototype.slice.call(arguments));
}

var P = F.leu_extend(abstractFilter).prototype;


P.apply_filter = function (current_value, params, field_name) {
    return this.create_invalid_value(field_name, 'value is rejected by none');// reject any input value
};

export default F;


